import { ApplicationEnum } from ".././../enums/enums";
import { IServiceLocationResponse } from "../../services/location-service";

export class ServiceLocation implements IServiceLocationResponse {
    public Id: string = "";
    public Code: number = null;
    public Start: string = null;
    public StartTime: string = null;
    public End?: string = null;
    public EndTime?: string = null;

    public constructor(data?: ServiceLocation) {
        if (data) {
            Object.assign(this, data);
        }
    }
}
